import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { FormLabel, Grid } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import ImageUuids from "../../Producten/ImageUuids";

export default function Media() {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody>
          <Grid container spacing={1}>
            <Grid container item lg={6} xs={12}>
              <Grid item xs={12}>
                <h3>
                  <TranslationWrapper tDefault={"Media"} tKey={"vestigingen.form.media.headers.media"} />
                </h3>
              </Grid>
              <Grid item xs={12}>
                <FormLabel>
                  <TranslationWrapper
                    tDefault={"Afbeelding(en)"}
                    tKey={"producten.form.branding.afbeelding.label.imgid"}
                  />
                </FormLabel>
                <ImageUuids fileType={"file"} />
              </Grid>
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}
